import React from 'react';
import { motion } from 'framer-motion';

const CSRPartners = () => {
  const partners = [
    { name: 'Tata Group', logo: 'https://via.placeholder.com/200x80/1f2937/ffffff?text=TATA' },
    { name: 'Reliance', logo: 'https://via.placeholder.com/200x80/1f2937/ffffff?text=RELIANCE' },
    { name: 'Infosys', logo: 'https://via.placeholder.com/200x80/1f2937/ffffff?text=INFOSYS' },
    { name: 'Wipro', logo: 'https://via.placeholder.com/200x80/1f2937/ffffff?text=WIPRO' },
    { name: 'Mahindra', logo: 'https://via.placeholder.com/200x80/1f2937/ffffff?text=MAHINDRA' },
    { name: 'Bharti Airtel', logo: 'https://via.placeholder.com/200x80/1f2937/ffffff?text=AIRTEL' }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">CSR Partners</h2>
          <p className="text-xl text-gray-600 mb-8">
            Align your CSR with dignity & empowerment
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-orange-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-orange-700 transition-colors duration-200"
          >
            Partner with Us
          </motion.button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center"
        >
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex items-center justify-center"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-12 w-auto opacity-60 hover:opacity-100 transition-opacity duration-300"
              />
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-16 bg-white rounded-xl p-8 shadow-lg"
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Why Partner with Us?</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎯</span>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Measurable Impact</h4>
              <p className="text-gray-600 text-sm">Track real-time progress and transformation stories</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📊</span>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Transparency</h4>
              <p className="text-gray-600 text-sm">Complete financial transparency and regular reporting</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🏆</span>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Recognition</h4>
              <p className="text-gray-600 text-sm">Brand association with social transformation</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CSRPartners;